/**
 * @module ボタン共通コンポーネント
 */
export default {
  data() {
    return {
      type1: 1, // いずれ定数一覧に移動
      type2: 2,
      type3: 3,
      type4: 4,
    };
  },
  props: {
    buttonType: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      required: true,
    },
    disableFlag: {
      type: Boolean,
      default: false,
    },
    onClick: {
      type: Function,
      default: () => {},
    },
    buttonSize250: {
      type: Boolean,
      default: true,
    },
  },
};
